import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { subscriptionsQueryOptions } from '../constants'
import { customQueryClient } from '../../config/query-client'
/**
 * Fetches all subscriptions.
 * @param {Object} options - Additional options for the query.
 * @returns {Object} - Returns a list of subscriptions
 */

export const useGetSubscriptionsQuery = (options) => {
  const handleQuery = async () => {
    const config = {
      method: 'get'
    }

    const { data } = await api(`/api/subscriptions`, config)

    return data
  }

  return useQuery({
    queryKey: [subscriptionsQueryOptions.GET_SUBSCRIPTIONS],
    queryFn: handleQuery,
    ...options
  })
}

// Selectors
export const getSubscriptions = () => {
  return customQueryClient.getQueryData([
    subscriptionsQueryOptions.GET_SUBSCRIPTIONS
  ])
}

// HOC
export const withGetSubscriptions = (WrappedComponent) => {
  return (props) => {
    const { data: subscriptions } = useGetSubscriptionsQuery()
    return <WrappedComponent {...props} subscriptions={subscriptions} />
  }
}
